import { AccountsPayableItem } from 'models/AccountsPayable'

import { formatMoney } from 'utils'

const compositionDetailMapper = (expenseComposition: AccountsPayableItem[]) => {
  return expenseComposition?.map((item) => ({
    description: item?.description || '',
    amountUnit: formatMoney(item?.amountUnit) || '',
    quantity: item?.quantity || '',
    amountBilled: formatMoney(item?.amountBilled) || ''
  }))
}

export default compositionDetailMapper
